import * as React from 'react';
export const IcVideoSurveillance = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.13 8.05L8.42 3.3a3 3 0 00-3.95 1.34L2.3 9a2.93 2.93 0 001.35 4l4.22 2-1.49 3H3a1 1 0 000 2h4a1 1 0 00.89-.55l1.78-3.55 3.68 1.8a3 3 0 004-1.34L19.47 12a2.93 2.93 0 00-1.34-3.95zm3.32 4.35a1 1 0 00-1.32.45l-1.73 3.51a1 1 0 00.45 1.3 1 1 0 001.31-.44l1.74-3.51a1 1 0 00-.45-1.31z'
      fill='currentColor'
    />
  </svg>
);
